import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { GlobalProvider } from "./context/GlobalProvider";
import AnalyticsScript from "./AnalyticsScript";
import * as serviceWorker from "./serviceWorker";

import "./i18n";
import "./style.scss";

// Get the root DOM element
const container = document.getElementById("root");
const root = createRoot(container);

// Render the app
root.render(
  <Suspense fallback={<div>Loading...</div>}>
    <GlobalProvider>
      <App />
       {window.location.origin.includes("localhost") &&  <AnalyticsScript />}
    </GlobalProvider>
  </Suspense>
);

// Service worker
serviceWorker.unregister();
